import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-r from-slate-50 to-white p-4 sm:p-6 border-b border-slate-200 min-w-0 overflow-x-auto" }
const _hoisted_2 = { class: "grid grid-cols-1 min-[480px]:grid-cols-2 lg:grid-cols-12 gap-4 min-w-0" }
const _hoisted_3 = {
  key: 0,
  class: "lg:col-span-3 min-w-0"
}
const _hoisted_4 = { class: "lg:col-span-2 min-w-0" }
const _hoisted_5 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mt-4 pt-4 border-t border-slate-200 min-w-0" }
const _hoisted_6 = { class: "flex items-center gap-2 text-sm text-slate-600 min-w-0" }
const _hoisted_7 = { class: "font-semibold text-slate-900 tabular-nums" }

import AdminFormSearchInput from "@/share/components/admin/AdminFormSearchInput.vue";
import AdminFormSelectField, {
  type AdminSelectOption,
} from "@/share/components/admin/AdminFormSelectField.vue";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PedidosFiltros',
  props: {
    params: {},
    total: {},
    searchPlaceholder: { default: "Cliente, correo, documento, ID pedido, orden pasarela o cupón…" },
    showEstadoFiltro: { type: Boolean, default: false }
  },
  emits: ["search", "estado-change", "limit-change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const estadoPedidoOptions: AdminSelectOption[] = [
  { value: "", label: "Todos los estados" },
  { value: "Pendiente", label: "Pendiente" },
  { value: "Pagado", label: "Pagado" },
  { value: "Completado", label: "Completado" },
];

const limitOptions: AdminSelectOption[] = [
  { value: "10", label: "10" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
];

const estadoModel = computed(() =>
  props.params.estadoNombre != null && props.params.estadoNombre !== ""
    ? String(props.params.estadoNombre)
    : ""
);

const limitModel = computed(() => String(props.params.limit ?? 10));

const updateSearch = (value: string) => emits("search", value);

const updateLimit = (value: string) => emits("limit-change", Number(value));

const updateEstado = (value: string) => {
  emits("estado-change", value);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(__props.showEstadoFiltro ? 'lg:col-span-5 min-w-0' : 'lg:col-span-6 min-w-0')
      }, [
        _createVNode(AdminFormSearchInput, {
          "input-id": "filtros-pedidos-search",
          label: "Buscar pedido",
          "model-value": props.params.search ?? '',
          placeholder: props.searchPlaceholder,
          "onUpdate:modelValue": updateSearch
        }, null, 8, ["model-value", "placeholder"])
      ], 2),
      (__props.showEstadoFiltro)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AdminFormSelectField, {
              "select-id": "filtros-pedidos-estado",
              label: "Estado",
              "model-value": estadoModel.value,
              options: estadoPedidoOptions,
              "onUpdate:modelValue": updateEstado
            }, null, 8, ["model-value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AdminFormSelectField, {
          "select-id": "filtros-pedidos-limit",
          label: "Mostrar",
          "model-value": limitModel.value,
          options: limitOptions,
          "onUpdate:modelValue": updateLimit
        }, null, 8, ["model-value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(props.total), 1),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "truncate" }, "pedidos encontrados", -1))
      ])
    ])
  ]))
}
}

})